import { Card, Row } from "antd";
import { styled } from "styled-components";

export const StyledDiv = styled.div`
    background-image: url("/loginBg2.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledCard = styled(Card)`
width: 80%;
  min-height: 30%;
  .ant-card-body{
    
  }
`;
export const StyledDTitleDiv = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
`;
